import type { RefObject } from 'react'
import { useEffect, useState } from 'react'
import { PERSON_LAYOUT, Z_STACK, computePersonRect } from '../config/layout'

export function PersonComposite({
  videoRef,
  visible,
  mirrored = true,
}: {
  videoRef: RefObject<HTMLVideoElement | null>
  visible: boolean
  mirrored?: boolean
}) {
  const [rect, setRect] = useState(() =>
    computePersonRect(window.innerWidth, window.innerHeight),
  )

  useEffect(() => {
    const update = () =>
      setRect(computePersonRect(window.innerWidth, window.innerHeight, PERSON_LAYOUT))
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return (
    <div
      className="person-composite"
      style={{
        position: 'fixed',
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        zIndex: Z_STACK.person,
        pointerEvents: 'none',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s ease',
        borderRadius: '18px 18px 8px 8px',
        overflow: 'hidden',
        boxShadow:
          '0 0 0 1px rgba(255,255,255,0.08), 0 20px 60px rgba(0,0,0,0.55), 0 0 40px rgba(0,200,255,0.12)',
      }}
    >
      <video
        ref={videoRef}
        playsInline
        muted
        autoPlay
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: mirrored ? 'scaleX(-1)' : undefined,
          filter: 'contrast(1.05) saturate(1.05)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(to top, rgba(5,6,10,0.55) 0%, transparent 35%, transparent 70%, rgba(5,6,10,0.2) 100%)',
          pointerEvents: 'none',
        }}
      />
    </div>
  )
}
